<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 3C0 2.17157 0.671574 1.5 1.5 1.5H22.5C23.3284 1.5 24 2.17157 24 3V6C24 6.82843 23.3284 7.5 22.5 7.5V18.75C22.5 20.8211 20.8211 22.5 18.75 22.5H5.25C3.17893 22.5 1.5 20.8211 1.5 18.75V7.5C0.671573 7.5 0 6.82843 0 6V3ZM3 7.5V18.75C3 19.9926 4.00736 21 5.25 21H18.75C19.9926 21 21 19.9926 21 18.75V7.5H3ZM22.5 3H1.5V6H22.5V3ZM7.5 11.25C7.5 10.8358 7.83579 10.5 8.25 10.5H15.75C16.1642 10.5 16.5 10.8358 16.5 11.25C16.5 11.6642 16.1642 12 15.75 12H8.25C7.83579 12 7.5 11.6642 7.5 11.25Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'MaterialsIcon'
}
</script>